//* Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

//* Add the Web App's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBMoaKs3E7rBz-j6SQ4I9owSpSNCbTUciM",
  authDomain: "voscoinbots.firebaseapp.com",
  projectId: "voscoinbots",
  storageBucket: "voscoinbots.firebasestorage.app",
  messagingSenderId: "60765062082",
  appId: "1:60765062082:web:ff30270101a50538d10c5b",
  measurementId: "G-D4Y7QLJP8T",
};

//* Initialize Firebase
let firebase_app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

//* Initialize Firebase Auth and set persistence
const auth = getAuth(firebase_app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Session persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Failed to set session persistence:", error);
  });

export { auth };
export default firebase_app;
